import { isLightBackgroundColor } from '@milanote/roma/utils/color';
import { getColorDefaultHexValue } from '../../../../../../common/colors/elementColorFormatUtil';

const getTargetPills = (labelId: string): Array<HTMLElement> => {
    return Array.from(document.querySelectorAll<HTMLElement>(`[data-tag-id="${labelId}"]`)).filter(
        (el): el is HTMLElement => el !== null,
    );
};

const applyLabelColorStyles = (pill: HTMLElement, colorValue: string) => {
    const color = getColorDefaultHexValue(colorValue);
    const textColor = isLightBackgroundColor(color)
        ? 'var(--ws-element-dark-text-on-color)'
        : 'var(--ws-element-light-text-on-color)';

    pill.style.backgroundColor = color;
    pill.style.color = textColor;
};

export const clearTemporaryLabelColorStyles = (labelId: string) => {
    getTargetPills(labelId).forEach((pill) => {
        pill.style.removeProperty('background-color');
        pill.style.removeProperty('color');
    });
};

export const setTemporaryLabelColorStyles = (labelId: string, colorValue: string | null) => {
    if (!colorValue) {
        clearTemporaryLabelColorStyles(labelId);
        return;
    }

    getTargetPills(labelId).forEach((pill) => {
        applyLabelColorStyles(pill, colorValue);
    });
};
